class Accordion {
  constructor() {
  }

  init() {
    return new Promise((resolve, reject) => {
      this.bindListeners();
      resolve();
    });
  }

  bindListeners() {
    const _this = this;
    document
      .querySelectorAll('.accordion__toggle-all__button')
      .forEach((btn) => (btn.onclick = _this.toggleAll.bind(_this)));
  }

  toggleAll(e) {
    const target = e.currentTarget;
    const parent = target.closest('section');

    target._toggleAriaExpanded();
    const currentState = target.getAttribute("aria-expanded");

    parent.querySelectorAll('details').forEach(accordion => {
      if (currentState === 'true')
        accordion.open = currentState;
      else
        accordion.removeAttribute('open');
    });
  }
}

BarbaController.addObject(new Accordion());
